mobileSize = 1000;

$(document).ready(function(){
  // General Message
  $('.generalmessage').prependTo('header');

  // Directions
  $('.standAloneDirections').text('Directions');

  // Ticket Animation
  $('.ticket').hover(function() {
    $(this).addClass('animate__animated animate__tada');
  }, function() {
    $(this).removeClass('animate__tada');
  });

  // Countdown Placement
  $('.countdown-wrapper').insertBefore('.content');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);
});